import type { MonitioAPI } from "@root/types.api.local";
import type { AxiosInstance } from "axios";

export default (axios: AxiosInstance) => ({
  get() {
    return axios.get("/v1/TimeZones");
  },
});
